export const SEARCH = 'Dyzio/Search/SEARCH';
export const LOAD_TRENDING = 'Dyzio/Search/LOAD_TRENDING';
export const LOADING = 'Dyzio/Search/LOADING';
export const MOVE_PAGE = 'Dyzio/Search/MOVE_PAGE';
export const SORT = 'Dyzio/Search/SORT';



// WEBPACK FOOTER //
// ./src/containers/search/constants.js